import { Flex } from './Flex';

// TODO: in v9, move styled() from Flex.jsx to here
export var StyledFlex = Flex;